// extracted by mini-css-extract-plugin
export var checkbox = "_5p-0";
export var circle = "_5p-3";
export var horizontalContainer = "_5p-7";
export var sm = "_5p-5";
export var switch0 = "_5p-2";
export var switchDisabled = "_5p-8";
export var switchEnabled = "_5p-1";
export var textSwitchContainer = "_5p-9";
export var textSwitchOption = "_5p-a";
export var textSwitchOptionSelected = "_5p-b";
export var verticalContainer = "_5p-6";
export var xs = "_5p-4";